import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=0a6b77ae"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"
import style0 from "./Spacer.vue?vue&type=style&index=0&id=0a6b77ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports